export default __webpack_public_path__ + "static/media/DailyThing_04.f3125235.png";